import { makeImmutable } from "../../core/makeImmutable";
export class SalesChannel {
    constructor(value) {
        this.value = value;
        makeImmutable(this);
    }
    get associationKey() {
        return this.toString();
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        if (this == SalesChannel.Sites) {
            return { tag: "Online" };
        }
        else if (this == SalesChannel.QRWaiter) {
            return { tag: "Bar" };
        }
        else if (this == SalesChannel.Apetilo) {
            return { tag: "Apetilo" };
        }
        else if (this == SalesChannel.IosApp) {
            return { tag: "IosApp" };
        }
        else if (this == SalesChannel.AndroidApp) {
            return { tag: "AndroidApp" };
        }
        else {
            return { tag: "Other" };
        }
    }
    get menuOrderOrigin() {
        if (this == SalesChannel.Sites ||
            this == SalesChannel.AndroidApp ||
            this == SalesChannel.IosApp) {
            return "Online";
        }
        else if (this == SalesChannel.QRWaiter) {
            return "Bar";
        }
        else if (this == SalesChannel.Apetilo) {
            return "Online";
        }
        else {
            return "Other";
        }
    }
}
SalesChannel.Apetilo = new SalesChannel("Apetilo");
SalesChannel.Sites = new SalesChannel("Sites");
SalesChannel.QRWaiter = new SalesChannel("QRWaiter");
SalesChannel.IosApp = new SalesChannel("IosApp");
SalesChannel.AndroidApp = new SalesChannel("AndroidApp");
